/** A non-2xx answer from the API. `detail` is the server's own wording. */
export class APIError extends Error {
  constructor(public status: number, public detail: string, public payload?: unknown, public code?: string) {
    super(detail);
    this.name = "APIError";
  }
}

/** `X-InSiSo-Auth` value for an account whose email address is not yet confirmed. */
export const EMAIL_NOT_VERIFIED = "email_not_verified";

/** The request never reached the application (server down, network, timeout). */
export class APIConnectionError extends APIError {
  constructor(detail: string) {
    super(0, detail);
    this.name = "APIConnectionError";
  }
}

/**
 * A 409 whose detail is an object (class resolution during model or capture-bundle
 * import). `payload` carries the server's missing / project_classes / suggestions.
 */
export class ModelImportRefused extends APIError {
  constructor(status: number, public info: Record<string, unknown>) {
    super(status, String(info.message ?? "Import refused"), info);
    this.name = "ModelImportRefused";
  }
  get missingClasses(): string[] { return (this.info.missing as string[]) ?? []; }
  get projectClasses(): string[] { return (this.info.project_classes as string[]) ?? []; }
  get suggestions(): Record<string, string> { return (this.info.suggestions as Record<string, string>) ?? {}; }
  get reasons(): string[] { return (this.info.reasons as string[]) ?? []; }
}

/** FastAPI's `detail` as one readable string: a plain string, or the messages of a validation error list. */
export function detailText(detail: unknown, fallback: string): string {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((d) => (d && typeof d === "object" && "msg" in d ? String((d as { msg: unknown }).msg) : ""))
      .map((m) => m.replace(/^Value error, /, ""))
      .filter(Boolean);
    if (msgs.length) return msgs.join("; ");
  }
  return fallback;
}
